import { ChangeDetectionStrategy, Component } from '@angular/core'
import { ViewableIssue } from 'src/app/account/components/issues-view/issues-view.component'
import { Application } from 'src/app/account/services/application.service'
import { SyncPair } from 'src/app/account/services/sync-pair.service'
import { buildAllMockIssues } from '../../mocks/showcase-issues-mocks'
import { TestPageMockState } from '../../showcase-mock-state'

/** Every mock issue type rendered with its production component. */
@Component({
  selector: 'showcase-issues',
  templateUrl: './showcase-issues.component.html',
  styleUrls: ['./showcase-issues.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ShowcaseIssuesComponent {
  readonly issues: ViewableIssue[] = buildAllMockIssues()

  constructor(private readonly state: TestPageMockState) {}

  get application(): Application {
    return this.state.application
  }

  get syncPair(): SyncPair {
    return this.state.syncPair
  }
}
